/**
 * 数字正则表达式，匹配仅包含数字的字符串
 */
export const NUMBER_REGEXP = /\d+/;

/**
 * 限购描述正则，匹配 " (已购/限制)" 格式，如 " (0/1)"
 * 第 1 个捕获组：已购买数量，第 2 个捕获组：限制数量
 */
export const LIMIT_DESC_REGEXP = /\s*\((\d+)\/(\d+)\)/;
